import * as React from 'react';
import { UserDetailNode } from '../../../schema';
import { Inject } from '../../helpers';
import { UserService } from '../../service/userService';
import { Loading } from 'sha-el-design/lib';

const { Consumer, Provider } = React.createContext<UserDetailNode>(null);

export { Consumer as UserConsumer };

export class UserContext extends React.Component<{}, UserDetailNode> {

  @Inject userService: UserService;

  constructor(props: {}) {
    super(props);

    this.state = null;
  }

  componentDidMount() {
    this.userService.user$.subscribe(
      (user) => {
        if (!user) {
          this.userService.init();
        }
        this.setState(user);
      },
    );
  }

  render() {
    return (
      <Provider value={this.state}>
        <Loading
          isLoading={!this.state}
          render={() => this.props.children}
        />
      </Provider>
    );
  }
}
